import { TFunction } from "next-i18next";

import defaultContent from "./spain";

const pageContent = (t: TFunction) => defaultContent(t);

export default pageContent;
